module.exports = {
  SATURN: "S", // rackspace
  PICKUP: "U", // rackspace
  CONSUMER: "CONSUMER", // rackspace
  PROPERTY: "PROPERTY", // rackspace
  DRIVER: "DRIVER", // rackspace
  DELIVERY_SIGNATURE_CODE: "P5", // GCP - Saturn
  COLLECTION_SIGNATURE_CODE: "C5", // GCP - Saturn
  SATURN_IMAGE_CODE: "S5", // GCP - Saturn
  PHOTO_IMAGE_CODE: "PH", // GCP - Saturn
  COLLECTION_INSTRUCTION: "CI", // GCP - Safe place photo taken from FMC
  EMPTY: "",
};
